"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Tabs = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _MenuItem = _interopRequireDefault(require("react-bootstrap/lib/MenuItem"));
var _Nav = _interopRequireDefault(require("react-bootstrap/lib/Nav"));
var _NavDropdown = _interopRequireDefault(require("react-bootstrap/lib/NavDropdown"));
var _NavItem = _interopRequireDefault(require("react-bootstrap/lib/NavItem"));
var _TabContainer = _interopRequireDefault(require("react-bootstrap/lib/TabContainer"));
var _TabContent = _interopRequireDefault(require("react-bootstrap/lib/TabContent"));
var _TabPane = _interopRequireDefault(require("react-bootstrap/lib/TabPane"));
var _excluded = ["id", "children"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
// if we pass id to NavDropdown, then TabContainer will flood with a lot of warnings
// that it manually manages id of children, but at the same time Typescript requires id to be passed
// so we add wrapper component to mute warning but still check for id
var CustomDropdown = function CustomDropdown(_ref) {
  var id = _ref.id,
    children = _ref.children,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_NavDropdown["default"], (0, _extends2["default"])({
    id: id !== null && id !== void 0 ? id : 'tabs-navigation-dropdown',
    className: "tabs-navigation__dropdown"
  }, props), children);
};
var Tabs = exports.Tabs = /*#__PURE__*/function (_PureComponent) {
  function Tabs() {
    var _this;
    (0, _classCallCheck2["default"])(this, Tabs);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, Tabs, [].concat(args));
    (0, _defineProperty2["default"])(_this, "state", {
      activeKey: undefined
    });
    (0, _defineProperty2["default"])(_this, "handleTabSelect", function (activeKey) {
      var onTabSelect = _this.props.onTabSelect;
      _this.setState({
        activeKey: activeKey
      });
      if (onTabSelect) {
        onTabSelect(activeKey);
      }
    });
    return _this;
  }
  (0, _inherits2["default"])(Tabs, _PureComponent);
  return (0, _createClass2["default"])(Tabs, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props = this.props,
        defaultActiveKey = _this$props.defaultActiveKey,
        tabs = _this$props.tabs;
      if (tabs.length) {
        this.setState({
          activeKey: defaultActiveKey || tabs[0].key
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
        withContentAnimation = _this$props2.withContentAnimation,
        withDropdownView = _this$props2.withDropdownView,
        tabs = _this$props2.tabs,
        tabsId = _this$props2.tabsId,
        defaultActiveKey = _this$props2.defaultActiveKey,
        onTabClick = _this$props2.onTabClick;
      var activeKey = this.state.activeKey;

      // Render nothing if tabs array is empty
      if (!tabs.length) {
        return null;
      }
      var tabsClasses = (0, _classnames["default"])('tabs', {
        'tabs_with-dropdown': withDropdownView
      });
      var activeTab = tabs.find(function (tab) {
        return tab.key === activeKey;
      });
      var activeTabTitle = activeTab ? activeTab.title : activeKey;
      var dropdownTitle = /*#__PURE__*/_react["default"].createElement("div", {
        className: "tabs-navigation-dropdown__title"
      }, activeTabTitle, /*#__PURE__*/_react["default"].createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "16",
        height: "16",
        viewBox: "0 0 16 16"
      }, /*#__PURE__*/_react["default"].createElement("path", {
        fill: "none",
        fillRule: "evenodd",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: "3",
        d: "M5.5 13.5L10.5 8.5 5.5 3.5",
        transform: "rotate(90 8 8.5)"
      })));
      return /*#__PURE__*/_react["default"].createElement(_TabContainer["default"], {
        id: tabsId,
        defaultActiveKey: defaultActiveKey || tabs[0].key
        /**
         * Proper type declaration is missing, `onSelect` actually has SelectCallback type;
         * https://github.com/DefinitelyTyped/DefinitelyTyped/blob/master/types/react-bootstrap/index.d.ts#L27-L35
         */,
        onSelect: this.handleTabSelect
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: tabsClasses
      }, /*#__PURE__*/_react["default"].createElement(_Nav["default"], {
        bsStyle: "pills",
        className: "tabs-navigation"
      }, tabs.map(function (tab) {
        return /*#__PURE__*/_react["default"].createElement(_NavItem["default"], {
          key: tab.key,
          className: "tabs-navigation-item",
          eventKey: tab.key,
          onClick: onTabClick
        }, /*#__PURE__*/_react["default"].createElement("div", {
          className: "title text_lg"
        }, tab.title));
      }), withDropdownView && /*#__PURE__*/_react["default"].createElement(CustomDropdown, {
        title: dropdownTitle
      }, tabs.map(function (tab) {
        return /*#__PURE__*/_react["default"].createElement(_MenuItem["default"], {
          key: tab.key,
          eventKey: tab.key,
          onClick: onTabClick
        }, /*#__PURE__*/_react["default"].createElement("div", {
          className: "title"
        }, tab.title));
      }))), /*#__PURE__*/_react["default"].createElement(_TabContent["default"], {
        className: "tabs-content",
        animation: withContentAnimation
      }, tabs.map(function (tab) {
        return /*#__PURE__*/_react["default"].createElement(_TabPane["default"], {
          unmountOnExit: true,
          eventKey: tab.key,
          key: tab.key
        }, tab.content);
      }))));
    }
  }]);
}(_react.PureComponent);
(0, _defineProperty2["default"])(Tabs, "defaultProps", {
  withContentAnimation: true,
  withDropdownView: true,
  defaultActiveKey: undefined,
  onTabClick: undefined,
  onTabSelect: undefined
});